

export const navLinks = [
  {
    label: 'videography',
    pathname: '/',
    hash: '#videography',
  },
  {
    label: 'Services',
    pathname: '/',
    hash: '#services',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about-us',
  },
  {
    label: 'Clients',
    pathname: '/',
    hash: '#clients',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },

];

export const socialLinks = [
  {
    label: "instagram" ,
    url: `https://www.instagram.com/shutterflyeg`,
    icon: "instagram" ,
  },
  {
    label: "whatsapp",
    url: "https://api.whatsapp.com/send?phone=201210864493&text=Hello%20I%20am%20interested%20in%20your%20services",
    icon: "whatsapp",
  },
  {
    label: 'facebook',
    url: `https://web.facebook.com/shutterflyeg`,
    icon: 'facebook',
  },
  {
    label: 'gmail',
    url: "mailto:Info@shutterfly-eg.com?subject=Shutter%20Fly%20website%20(services)&body=Hello%20Shutter%20Fly%20Team%20%F0%9F%91%8B%2C%0A%0AI%20hope%20you're%20doing%20well!%20%F0%9F%98%8A%0A%0AI'm%20excited%20to%20learn%20more%20about%20your%20fantastic%20services%20and%20how%20they%20can%20help%20me%20reach%20my%20goals.%20Could%20you%20kindly%20share%20more%20details%20or%20any%20relevant%20information%3F%20%20%F0%9F%92%A8%0A%0ALooking%20forward%20to%20hearing%20from%20you%20soon!%20%F0%9F%9A%80%0A%0A%22write%20more%20if%20you%20need%22",
    icon: 'gmail',
  },
  {
    label: 'linkedin',
    url: "https://www.linkedin.com/login/ar",
    icon: 'linkedin',
  },
  {
    label: 'behance',
    url: "https://www.behance.net/shutterfly-eg",
    icon: 'behance',
  },
];
